<template>
    <div class="">

        <Atom1Loader v-if="loading" />

        <div class="" v-else>
            <div class="card">
                <div class="card-body">
                    <h3 class="card-title">Nuevo Rol</h3>
                    <form class="row g-3">
                        <div class="col-md-12">
                            <div class="form-floating">
                                <input class="form-control" placeholder="Digite el rol..." v-model="name">
                                <label>Rol</label>
                                <div v-if="v$.name.$error" class="invalid-feedback animated fadeInDown"
                                    style="display: block;">
                                    {{ validationMessage(v$.name) }}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="card shadow mb-4">
                <div class="card-body">
                    <h3 class="card-title">Permisos</h3>
                    <div class="row">
                        <div class="col-md-3 mt-3" v-for="(module, i) in aPermissions" :key="i">
                            <h5>{{ module.module }}</h5>
                            <div v-for="permission in module.permissions" :key="permission.id" class="form-check form-switch">
                                <div class="form-check form-switch">
                                    <input class="form-check-input permission"
                                           type="checkbox"
                                           v-model="permission.selected"
                                           :checked="permission.selected">
                                    <label class="form-check-label" for="permission_@permission.Id">{{ permission.name }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text-center">
                <button v-if="type=='C'" type="submit" class="btn btn-primary" @click.prevent="createRole">Guardar</button>
                <button v-else type="submit" class="btn btn-primary" @click.prevent="updateRole">Guardar</button>
            </div>
        </div>

    </div>
</template>

<script>

import useValidate from '@vuelidate/core';
import { required, minLength } from '@vuelidate/validators';

import toastMixin from '@/mixins/toastMixin';
import validatorMixin from '@/mixins/validatorMixin';
import accountMixin from '@/mixins/accountMixin';

import axios from "axios";

import { checkCatch } from "@/utils";

import Atom1Loader from '@/components/Utils/Loaders/Atom1Loader.vue';

export default {    

    name: 'RoleManagerComponent',

    mixins: [validatorMixin, toastMixin, accountMixin],

    components: { Atom1Loader },

    props: {

        type: { type: String, required: true },
        roleId: { type: Number, default: 0 }
    },

    data() {

        return {

            v$: useValidate({ $stopPropagation: true }),

            loading: false,

            title: this.type == 'E' ? 'Editar rol' : 'Crear rol',

            // id: 0,
            name: '',
            permissions: [],

            aPermissions: [],
        };
    },

    validations() {

        return {

            name: { required, minLength: minLength(3) },
        };
    },

    async mounted() {

        if (this.type == 'E') {

            await this.getRole();
        }

        await this.getPermissions();
    },

    methods: {

        async getPermissions() {

            this.loading = true;

            const headers = {

                'Authorization': `Bearer ${this.accountUser.token}`
            };
            
            await axios.get(`${this.$env.API_BASE_URL}get_permissions_by_module/`, { headers }).then((response) => {

                const { data } = response;

                this.aPermissions = data.map(item => {

                    item.permissions = item.permissions.map(permission => {

                        if (this.type == 'C'){

                            permission.selected = false;

                        } else {
                            
                            permission.selected = this.permissions.some(obj => obj.id === permission.id);
                        }

                        return permission;
                    });

                    return item;
                });

                this.loading = false;

            }).catch((error) => {

                checkCatch(error);
            });
        },

        async getRole(){

            this.loading = true;

            const headers = {

                'Authorization': `Bearer ${this.accountUser.token}`
            };
            
            await axios.get(`${this.$env.API_BASE_URL}roles/${this.roleId}/`, { headers }).then((response) => {

                const { data } = response;

                // this.id = data.id;
                this.name = data.name;
                this.permissions = data.permissions_list;

                this.loading = false;

            }).catch((error) => {

                checkCatch(error);
            });

        },

        async createRole() {

            this.v$.$validate();

            if (this.v$.$error) {

                this.showNotification({
                    title: 'Debe ajustar los errores de validación',
                    description: '',
                    type: 'danger',
                    timeout: 4,
                });
                return;
            }

            this.loading = true;

            let permissionsIds = this.aPermissions
                                     .map(permission => permission.permissions) // Extraemos el array de permisos de cada elemento
                                     .flat() // Aplanamos el array de arrays en un solo array
                                     .filter(p => p.selected) // Filtramos solo los permisos seleccionados
                                     .map(p => p.id); // Obtenemos solo los ids de los permisos seleccionados

            const data = {

                name: this.name,
                permissions: permissionsIds,
            };

            const headers = {

                'Authorization': `Bearer ${this.accountUser.token}`
            };

            await axios.post(`${this.$env.API_BASE_URL}roles/create/`, data, { headers })
                .then(() => {

                    this.$emit('roleCreated');
                    this.loading = false;

                    this.showNotification({
                        title: 'Éxito',
                        description: 'Rol creado con éxito',
                        timeout: 4,
                    });

                }).catch((error) => {

                    checkCatch(error);
                });
        },

        async updateRole() {

            this.v$.$validate();

            if (this.v$.$error) {

                this.showNotification({
                    title: 'Debe ajustar los errores de validación',
                    description: '',
                    type: 'danger',
                    timeout: 4,
                });
                return;
            }

            this.loading = true;

            let permissionsIds = this.aPermissions
                                     .map(permission => permission.permissions) // Extraemos el array de permisos de cada elemento
                                     .flat() // Aplanamos el array de arrays en un solo array
                                     .filter(p => p.selected) // Filtramos solo los permisos seleccionados
                                     .map(p => p.id); // Obtenemos solo los ids de los permisos seleccionados

            const data = {

                name: this.name,
                permissions: permissionsIds,
            };

            const headers = {

                'Authorization': `Bearer ${this.accountUser.token}`
            };

            await axios.put(`${this.$env.API_BASE_URL}roles/update/${this.roleId}/`, data, { headers })
                .then(() => {

                    this.$emit('roleUpdated');
                    this.loading = false;

                    this.showNotification({
                        title: 'Éxito',
                        description: 'Rol actualizado con éxito',
                        timeout: 4,
                    });

                }).catch((error) => {

                    checkCatch(error);
                });
        },
    },    
}
</script>